module.exports = __webpack_public_path__ + "officialStatic/img/wx-spec-shengxin.8e48519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wx-spec-shengxin.png
// module id = i4WM
// module chunks = 0